// extracted by mini-css-extract-plugin
export default {"printElement":"v3_printElement__OtDZz","hideElement":"v3_hideElement__hQsU3","noBorder":"v3_noBorder__+An3g"};